// src/utils/logos.js
function importAll(r) {
  const images = {};
  r.keys().forEach((key) => {
    const cleanName = key
      .replace('./', '') // "./companyA .png" → "companyA .png"
      .replace(/\.[^/.]+$/, '') // "companyA .png" → "companyA "
      .replace(/\s+/g, '') // "companyA " → "companyA"
      .trim(); // 혹시 모를 공백 제거

    images[cleanName] = r(key);
  });
  return images;
}

// src/assets/logo 폴더의 png/jpg/svg 전체
export const logos = importAll(require.context('../../assets/logo', false, /\.(png|jpe?g|svg)$/));
